<template>
    <section class="culture"  v-if="loaded && ready" >


      <div v-on:mouseover="restTeam()">
        <hero-culture :lang="lang" :cultureData="cultureData"  :isMobile="isMobile"> </hero-culture>
      </div>



      <div class="container culture-headline" :class="{'vis' :  offSet.last >= 0}" >

        <h1 v-if="lang === 0">Liderança</h1>
        <h1 v-if="lang === 1">Leadership</h1>
      </div>

      <team :lang="lang" :offSet="offSet" :isMobile="isMobile" v-if="!isMobile" :partners="true" :offsetIndex="1" ></team>

      <partners-mob :lang="lang" :offSet="offSet" :isMobile="isMobile" v-if="isMobile" :partners="true" :offsetIndex="1"></partners-mob>
      <div class="container culture-headline" :class="{'vis' :  offSet.last >= 2}" >

        <h1 v-if="lang === 0">Equipa</h1>
        <h1 v-if="lang === 1">Team</h1>
      </div>
      <team :lang="lang" :offSet="offSet" :isMobile="isMobile" v-if="!isMobile" :partners="false" :offsetIndex="3"></team>
      <team-mob :lang="lang" :offSet="offSet" :isMobile="isMobile" v-if="isMobile" :partners="false" :offsetIndex="3"> </team-mob>

      <with-us :lang="lang" :offSet="offSet" :cultureData="cultureData" :isMobile="isMobile" :offsetIndex="4"></with-us>


      <div class="container" :class="{'vis' :  offSet.last >= 5}" >


        <div class="culture-NOSSA">



        </div>
        <div class="galery-filters">
          <div  class="galery-filters-all"  v-on:click="setFilter(9999)">


            <span v-if="lang === 0">Tudo</span>
            <span v-if="lang === 1">All</span>


          </div>
          <div v-for="(item, index) in  galeryData" class="galery-filters-item" v-on:click="setFilter(index)" :class="{'active' : isActive(index) }" > {{item.label[lang].name}}</div>

        </div>



        <div class="grid-galery">
          <transition-group name="fade" >
            <div v-for="(item, index) in  galeryList" :key="index" class="galery-item" :class="'_' + item.type"  v-if="isActive(item.parent) && index <= imgLoads">


              <media-type :className="'galery-media'" :obj="item" :dynAlt="item.alt" > </media-type>
            </div>
          </transition-group>
        </div>

        <div id="lazzy"></div>
      </div>


      <div class="project-footer">
        <footer-nossa :lang="lang" :isMobile="isMobile"></footer-nossa>
      </div>


    </section>
</template>

<script>





    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, PROJ, WP} from '../main';
    import MediaType from "./Modules/MediaType";


    import FooterNossa from "./FooterNossa";
    import Icons from "./Modules/Icons";
    import HeroCulture from "./Modules/HeroCulture";
    import Team from "./Modules/Team";
    import WithUs from "./Modules/WithUs";
    import TeamMob from "./Modules/TeamMob";
    import PartnersMob from "./Modules/PartnersMob";

   // import Masonry from "masonry-layout/masonry";



    export default {


        name: 'culture',
      components: {PartnersMob, TeamMob, WithUs, Team, HeroCulture, Icons, FooterNossa, MediaType},
      props: ['actRoute', 'isMobile', 'lang'],
        data() {
            return {
                actScreen: 0,
              projData: [],
              loaded: false,
              ready: false,
              galeryData: [],
              teamData: [],
              cultureData: [],
              galeryList: [],

              offSet: {
                  vis: [],
                  tops: [],
                  last: -1
              },
              activeFilters: [],
              activeFiltersInit: [],
              hasFooter: false,

              imgLoads: 5,
              isLazzy: true

            }
        },
      head: {
        title: function () {
          const _this = this;
          return {
            inner: 'NOSSA™',   separator: '|',   complement: 'Pessoas'
          }
        },


      },
      created() {
        const _this = this;

        //alert(this.$route.path.substring(9, this.$route.path.length))

        WP('culture', function (response){

          _this.cultureData = response[0];
          _this.loadGalery();

          console.log(response)

        });

      },
      mounted() {
        this.ready = true;
        this.init();
        //EVENTBUS.$on('AAA', AAA);
        //EVENTBUS.$emit('AAA', 0);
        $(window).scrollTop(0);
        $('body, html').scrollTop(0);




      },

      destroyed() {
        $(window).off();
      },

      methods: {

          loadGalery(){
            const _this = this;

            //alert(this.$route.path.substring(9, this.$route.path.length))

            WP('galery', function (response){

              _this.galeryData = response;



              for(let i  = 0; i < _this.galeryData.length; i++){


                if(i == 0){
                  _this.activeFilters.push(i);
                }


                _this.galeryData[i].items.forEach(function(obj, index){

                  let incObj = obj;
                  incObj.parent = i;
                  incObj.alt = _this.galeryData[i].label[_this.lang].name

                  _this.galeryList.push(incObj);




                });

              }



              _this.loaded = true;
              setTimeout(function() {
                 _this.init();
                _this.setFilter(9999);
              }, 200);


            });
          },




        init() {
          const _this = this;

          if(this.loaded && this.ready){


            setTimeout(function() {
              _this.initScroll();

            }, 200);



            $('main').css('pointer-events', 'auto');

          }
        },





        isActive(n) {
          let hasFilter = false;
          for(let i  = 0; i < this.activeFilters.length; i++){
            if(this.activeFilters[i] == n){
              hasFilter = true;

            }
          }

          return hasFilter;
        },

        setFilter(n){

          let hasFilter = false;


          this.imgLoads = this.galeryList.length;


          if(n != 9999){
            for(let i  = 0; i < this.activeFilters.length; i++){
              if(this.activeFilters[i] == n){
                hasFilter = true;
                this.activeFilters.splice(i, 1)
              }
            }

            if(!hasFilter){
              this.activeFilters.push(n);
            }
          }else{
            this.activeFilters = [];
            for(let i  = 0; i < this.galeryData.length; i++){
              this.activeFilters.push(i);
            }
            this.imgLoads = 5;
          }



        },




        getShuffledArr (arr){
          return [...arr].map( (_, i, arrCopy) => {
            var rand = i + ( Math.floor( Math.random() * (arrCopy.length - i) ) );
            [arrCopy[rand], arrCopy[i]] = [arrCopy[i], arrCopy[rand]]
            return arrCopy[i]
          })
        },


        initScroll(){
          const _this = this;


          setTimeout(() =>{



            $( window ).scroll(function(e) {

              _this.scrollEvt()
            });

            $( window ).resize(function() {
              _this.reseizeMe();
            });

            _this.reseizeMe();
            _this.scrollEvt();

          }, 100)




        },

        reseizeMe() {

          this.scrollEvt()
        },

        restTeam(){
          EVENTBUS.$emit('resetTeam' );
        },

        scrollEvt() {

          const _this = this;

          _this.offSet.act =  $( window ).scrollTop() +  $( window ).height();

          EVENTBUS.$emit('pauseVid');
         // EVENTBUS.$emit('resetTeam' );
          _this.offSet.tops = [];
          $('.container').each(function(i){

          //  _this.offSet.tops[i].top = $(this).offset().top;
            _this.offSet.tops.push($(this).offset().top);

            if(_this.offSet.act > (_this.offSet.tops[i]  + 100 )&&  !_this.offSet.vis[i]) {

              _this.offSet.last = i;
              _this.offSet.vis[i] = true;




            }



          });



          if($( window ).scrollTop() > $('.with-us').offset().top && !_this.isMobile){
            EVENTBUS.$emit('resetTeam');
          }


      //    EVENTBUS.$emit('resetTeam');


          //EVENTBUS.$emit('log', _this.offSet.tops[0]);


    //    console.log($('.container').length - 2, _this.offSet.last)


          if(_this.offSet.last >= ($('.container').length - 1)&&  !_this.hasFooter){

            EVENTBUS.$emit('showFooter');
            _this.hasFooter=true;

          }



          if(_this.offSet.act > $('#lazzy').offset().top &&  _this.isLazzy){
            _this.goLazzy();
          }







          /*



          if(this.offSet.act > this.offSet.off2.top &&  !this.offSet.vis2) {
            this.offSet.vis2 = true;

          }
*/



          // $( window ).scrollTop()
          // console.log(this.offSet );
        },

        goLazzy(){
          const _this = this;
          _this.isLazzy = false;
          console.log('lazzy')
          _this.imgLoads += 5;
          setTimeout(function () {
            _this.isLazzy = true;
          }, 800);

        }


        },
    };

</script>


// WEBPACK FOOTER //
// src/components/Culture.vue